/**
 *
 * @module playbackTelemetryConfiguration
 *
 */

import Services from './../services/entry';

/**
 *
 * @class PlaybackTelemetryConfiguration
 * @extends {SDK.Services.Media.StreamSampleConfiguration}
 * @since 2.0.0
 *
 */
export default class PlaybackTelemetryConfiguration extends Services.Media.StreamSampleConfiguration {}



// WEBPACK FOOTER //
// ./src/media/playbackTelemetryConfiguration.js